import { de, fr, enUS } from 'date-fns/locale'

/** Base UI language code (en / fr / de), independent of region (e.g. de-DE). */
export const normalizeUiLanguage = (lang: string | null | undefined) => {
  const base = (lang ?? 'en').toLowerCase().split('-')[0]
  if (base === 'fr' || base === 'de' || base === 'en') return base
  return 'en'
}

/** API schema / setting-key routes currently only accept fr | en — map de → en. */
export const toSchemaApiLocale = (
  lang: string | null | undefined
): 'en' | 'fr' => (normalizeUiLanguage(lang) === 'fr' ? 'fr' : 'en')

/** Déclaration agentique (vue, corrections) et schéma de formulaire : fr / en / de (TEC-1736). */
export const toDeclarationApiLocale = (
  lang: string | null | undefined
): 'en' | 'fr' | 'de' => normalizeUiLanguage(lang)

/** API dec_label_intls routes accept en / fr / de. */
export const toDecLabelApiLocale = (
  lang: string | null | undefined
): 'en' | 'fr' | 'de' => normalizeUiLanguage(lang)

export const getLocale = (lang: string | null | undefined) => {
  switch (normalizeUiLanguage(lang)) {
    case 'fr':
      return fr
    case 'de':
      return de
    case 'en':
    default:
      return enUS
  }
}
